import localeSettings from './settings';
import localZhTw from './zh-HK.json';
import localeLogin from '@/views/login/locale/zh-CN';

export default {
    ...localeSettings,
    ...localeLogin,
    ...localZhTw,
};
